import { SvgIcon, SvgIconProps } from "@mui/material";
import { ReactElement } from "react";

export type ShuttlerockIconProps = Omit<SvgIconProps, "color"> & {
  color?: SvgIconProps["color"] | "brand";
};

export const ShuttlerockIcon = ({ color, ...props }: ShuttlerockIconProps): ReactElement => {
  return (
    <SvgIcon
      {...props}
      {...(color && color !== "brand" ? { color } : undefined)}
      viewBox="5 39 230 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // `brand` renders the mark in the theme's ink so it stays legible in both
      // colour schemes — dark on light surfaces, light on dark ones.
      sx={[
        color === "brand" && { color: "text.primary" },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <path
        fill="currentColor"
        d="M216 154L204.146 165.854C182.611 144.32 152.861 131 120 131C87.1391 131 57.3893 144.32 35.8545 165.854L24 154L120 58L216 154Z"
      />
    </SvgIcon>
  );
};
